import { takeLatest, call, put, select } from 'typed-redux-saga'
import { errorHandler, gridSlice } from 'Modules'
import { Deserialize } from 'cerialize'
import { RequestParams, ResponseCatalog } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import {
	BlockProductNS,
	blockProductSlice,
	BlockProductGroupModel,
	blockProductGroupApi,
	blockProductGroupsSelector,
} from 'Pages/orders/blockProductGroup'

export function* getAllItemsSaga(
	requestParams?: RequestParams,
	clear?: boolean,
	callback?: Callback
) {
	let params = new RequestParams()
	let oldItems = new ResponseCatalog<BlockProductGroupModel>()
	if (clear) {
		yield* put(blockProductSlice.actions.clearAll())
	}
	if (!clear && requestParams?.page !== 1) {
		oldItems = yield* select(blockProductGroupsSelector.selectItems)
		params = yield* select(blockProductGroupsSelector.selectRequestParams)
	}
	const res = yield* call(blockProductGroupApi.getAll, requestParams || params)
	const items = new ResponseCatalog<BlockProductGroupModel>(res)
	const newItems = res.entries.map(
		(item): BlockProductGroupModel => Deserialize(item, BlockProductGroupModel)
	)
	items.entries = [...oldItems.entries, ...newItems]
	yield* put(blockProductSlice.actions.setRequestParams(requestParams || params))
	yield* put(blockProductSlice.actions.setAll(items))
	callback?.()
}

export function* getBlockGroupProductsSaga(action: BlockProductNS.GetBlockProductList) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear } = action.payload
		yield* call(getAllItemsSaga, params, clear)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

export function* createBlockGroupProductSaga(action: BlockProductNS.CreateBlockProduct) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		yield* call(blockProductGroupApi.createOne, action.payload)
		yield* call(getAllItemsSaga, undefined, true)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}
export function* updateBlockGroupProductSaga(action: BlockProductNS.UpdateBlockProduct) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { data, id } = action.payload
		yield* call(blockProductGroupApi.updateOne, data, id)
		yield* call(getAllItemsSaga, undefined, true)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

export function* deleteBlockGroupProductSaga(action: BlockProductNS.DeleteBlockProduct) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		yield* call(blockProductGroupApi.deleteOne, action.payload)
		yield* call(getAllItemsSaga, undefined, true)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

export function* blockProductGroup() {
	yield* takeLatest(blockProductSlice.actions.getAll.type, getBlockGroupProductsSaga)
	yield* takeLatest(blockProductSlice.actions.createOne.type, createBlockGroupProductSaga)
	yield* takeLatest(blockProductSlice.actions.updateOne.type, updateBlockGroupProductSaga)
	yield* takeLatest(blockProductSlice.actions.deleteOne.type, deleteBlockGroupProductSaga)
}
